import { SvgIcon, SvgIconProps } from "@mui/material";

export const Telegram = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.255 23.9671C22.9325 24.701 23.5616 23.1633 23.5616 23.1633L28 0.866361C27.9651 -0.636408 25.9381 0.272243 25.9381 0.272243L1.08994 10.0228C1.08994 10.0228 -0.0982929 10.4421 0.00655147 11.1761C0.111396 11.91 1.055 12.2595 1.055 12.2595L7.31071 14.3563C7.31071 14.3563 9.19791 20.5422 9.58234 21.7304C9.93182 22.8837 10.2464 22.9186 10.2464 22.9186C10.5958 23.0584 10.9104 22.8138 10.9104 22.8138L14.9643 19.1442L21.255 23.9671ZM22.3384 4.81502C22.3384 4.81502 23.2121 4.2908 23.1772 4.81502C23.1772 4.81502 23.317 4.88491 22.8627 5.37419C22.4433 5.79357 12.553 14.6704 11.2249 15.8586C11.1201 15.9285 11.0502 16.0334 11.0502 16.1732L10.6658 19.4583C10.5959 19.8078 10.1415 19.8427 10.0367 19.5282L8.39413 14.1462C8.32423 13.9365 8.39413 13.6918 8.60382 13.5521L22.3384 4.81502Z"
        fill="white"
      />
    </SvgIcon>
  );
};
